import React, {FC} from "react";
import {
    Button,
    Checkbox,
    Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle,
    LinearProgress,
    List,
    ListItem,
    ListItemIcon,
    ListItemText, Snackbar,
    Typography
} from "@material-ui/core";
import {AuthContext} from "../../../auth/components/AuthProvider";
import {useWorker} from "../../workers/redux/workers.hook";
import {EditableWorkerProfile} from "../../workers/screens/worker/EditableWorkerProfile";
import {useServices} from "../../services/redux/services.hook";
import {Service} from "../../services/redux/types";
import {useAppDispatch} from "../../../redux/redux.hook";
import {addWorkerServiceThunk, removeWorkerServiceThunk} from "../../workers/redux/workers.thunk";
import {FeWorker} from "../../workers/redux/types";
import {ExitToApp, InfoOutlined} from "@material-ui/icons";
import {Alert, AlertTitle} from "@material-ui/lab";
import {useLogout} from "../../../auth/redux/auth.hook";

const WorkerServiceListItem: FC<{ service: Service; worker: FeWorker; }> = ({service, worker}) => {
    const dispatch = useAppDispatch();
    const [dialogOpen, setDialogOpen] = React.useState(false);
    const addService = () => dispatch(addWorkerServiceThunk({
        serviceId: service.id,
        workerId: worker.id
    })).then(() => setShowSucces(service.name));
    const removeService = () => dispatch(removeWorkerServiceThunk({serviceId: service.id, workerId: worker.id}))
        .then(() => setDialogOpen(false))
        .catch(() => {
        });

    const [showSucces, setShowSucces] = React.useState<string | null>(null);

    const handleClearError = () => setShowSucces(null);

    const handleOnChange = (checked: boolean) => checked ? addService() : setDialogOpen(true)

    return (
        <React.Fragment>
            <Snackbar open={Boolean(showSucces)} onClose={handleClearError} autoHideDuration={6000} anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'center'
            }}>
                <Alert onClose={handleClearError} severity="success">
                    <AlertTitle>
                        Dienstleistung gespeichert
                    </AlertTitle>
                    Du wirst bei Buchungen nun für {showSucces} in erwägung gezogen.
                </Alert>
            </Snackbar>
            <Dialog open={dialogOpen} onClose={() => setDialogOpen(false)}>
                <DialogTitle>
                    <Typography variant="inherit" color="secondary">
                        Bist du sicher, dass du die folgende Diensleistung nicht mehr anbieten möchtest?
                    </Typography>
                </DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        <b>{service.name}</b>
                    </DialogContentText>
                    <div style={{marginBottom: 32, display: "flex", marginTop: 24}}>
                        <InfoOutlined color="primary"/>
                        <Typography variant="body2" style={{marginLeft: 8}} color="textSecondary">
                            Bereits bestätigte Aufträge mit Dienstleistungen, die evtl. abgewählt wurden, bleiben
                            erhalten.
                        </Typography>
                    </div>
                    <DialogActions>
                        <Button onClick={() => setDialogOpen(false)}>
                            Nein
                        </Button>
                        <Button color="primary" onClick={removeService}>
                            Ja, ich bin sicher
                        </Button>
                    </DialogActions>
                </DialogContent>
            </Dialog>
            <ListItem>
                <ListItemIcon>
                    <Checkbox
                        color="primary"
                        checked={worker.servicesIds.includes(service.id)}
                        onChange={(_e, checked) => handleOnChange(checked)}
                    />
                </ListItemIcon>
                <ListItemText>{service.name}</ListItemText>
            </ListItem>
        </React.Fragment>
    )
}

export const WorkerPersonalDataScreen: FC = () => {

    const {userId} = React.useContext(AuthContext);
    const {worker} = useWorker(userId);
    const services = useServices();
    const {logout} = useLogout();
    return (
        <div style={{padding: 16}}>
            <Typography color="primary" variant="h5" style={{marginBottom: 8}}>
                Meine Daten
            </Typography>
            {worker
                ? (
                    <React.Fragment>
                        <Typography color="textSecondary" style={{marginBottom: 8}}>
                            Stammdaten
                        </Typography>
                        <EditableWorkerProfile worker={worker} hideHourlyWage/>
                        <Typography color="textSecondary" style={{marginTop: 16}}>
                            Dienstleistungen
                        </Typography>
                        <List style={{overflow: 'auto'}}>
                            {services
                                .filter(s => s.active).map(s => (
                                    <WorkerServiceListItem service={s} worker={worker}/>
                                ))
                            }
                        </List>
                    </React.Fragment>
                )
                : <LinearProgress/>
            }
            <Button
                startIcon={<ExitToApp/>}
                style={{marginTop: 24}}
                variant="contained"
                color="primary"
                onClick={logout}
            >
                Ausloggen
            </Button>
        </div>
    )
}
